module.exports = __webpack_public_path__ + "static/media/snellenDemo.59eba1db.jpg";